// extracted by mini-css-extract-plugin
export var carrierNotice = "_lf-5";
export var carrierNoticePlaceholder = "_lf-6";
export var deliveryRow = "_lf-c";
export var fixedHeight = "_lf-4";
export var freightLogo = "_lf-b";
export var fullWidth = "_lf-3";
export var priceColumn = "_lf-7";
export var radioSelected = "_lf-9";
export var radioUnselected = "_lf-8";
export var selectedOption = "_lf-2";
export var selectedOptionContainer = "_lf-1";
export var selection = "_lf-0";
export var tallSkeletonText = "_lf-a";